import { Col, Row } from "react-bootstrap";

export default function LogoMascot() {
  return (
    <div
      style={{
        lineHeight: "2",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      {/* Tournament Logo Section */}

      {/* <div style={{ lineHeight: "2", marginTop: "50px" }}>
        <h3>आधिकारिक लोगो</h3>
        <br />
        <Row>
          <Col md={8}>
            <p style={{ textAlign: "justify", marginBottom: "15px" }}>
              राजगीर (बिहार) में आयोजित एशिया रग्बी अंडर-20 सेवेंस चैंपियनशिप का
              यह लोगो राज्य की ऐतिहासिक विरासत, सांस्कृतिक विविधता और खेल
              संस्कृति का जीवंत प्रतीक है।
            </p>
            <p style={{ textAlign: "justify", marginBottom: "15px" }}>
              BIHAR — यह शब्द केवल पाँच अक्षरों का संयोजन नहीं, बल्कि बिहार की
              आत्मा का चित्रात्मक परिचय है। हर अक्षर एक प्रतीक है, जो राज्य की
              सांस्कृतिक, ऐतिहासिक और प्राकृतिक विरासत की कहानी कहता है।
            </p>
          </Col>
          <Col md={4}>
            <img
              src="./img/AsiaRugbyU207s/logo.png"
              alt="Description"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Col>
        </Row>
        <br />
        <h4 style={{ textAlign: "justify" }}>अक्षरों का प्रतीकात्मक अर्थ:</h4>
        <br />
        <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
          <li style={{ listStyleType: "disc" }}>
            <b>B – बुद्ध और बोधि वृक्ष:</b>
            <p>
              यह अक्षर बोधगया और भगवान बुद्ध को दर्शाता है, जहाँ उन्हें ज्ञान की
              प्राप्ति हुई थी। यह बिहार की आध्यात्मिक विरासत और शांति के वैश्विक
              संदेश का प्रतीक है।
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>I – नदी और छठ पूजा:</b>
            <p>
              यह अक्षर बिहार की जीवन रेखा गंगा नदी और छठ पूजा की भावनात्मक छवि
              प्रस्तुत करता है। यह श्रद्धा, प्रकृति से जुड़ाव और सांस्कृतिक गौरव
              का प्रतीक है।
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>H – फसल कटाई:</b>
            <p>
              इसमें एक किसान को फसल काटते हुए दर्शाया गया है — यह बिहार की कृषि
              परंपरा, मेहनती ग्रामीण जीवन और राज्य की बागवानी उत्पादन में अग्रणी
              भूमिका को सम्मान देता है।
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>A – गौर और गौरैया:</b>
            <p>
              भारतीय गौर (राज्य पशु) और गौरैया (राज्य पक्षी) इस अक्षर में दर्शाए
              गए हैं। यह बिहार की जैव विविधता, पर्यावरणीय संतुलन और प्राकृतिक
              समृद्धि का प्रतीक है।
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>R – प्राचीन विश्वविद्यालयों के अवशेष:</b>
            <p>
              यह अक्षर नालंदा और विक्रमशिला विश्वविद्यालयों की ऐतिहासिक
              वास्तुकला से प्रेरित है — यह बिहार की प्राचीन शिक्षा प्रणाली,
              बौद्धिक विरासत और वैश्विक ज्ञान-परंपरा को दर्शाता है।
            </p>
          </li>
        </ul>
        <br />
        <h5 style={{ textAlign: "justify" }}>रंग योजना और भाव</h5>
        <br />
        <p style={{ textAlign: "justify" }}>
          इस लोगो में प्रयुक्त रंग — नीला, हरा और मिट्टी के रंग — बिहार की
          प्रकृति, संस्कृति और जीवन ऊर्जा को व्यक्त करते हैं। आधुनिक रेखांकन
          शैली इसे समकालीन बनाते हैं, जबकि प्रतीकात्मकता इसे गहराई देती है।
        </p>
        <p style={{ textAlign: "justify" }}>
          यह डिज़ाइन सिर्फ एक पहचान नहीं, बल्कि बिहार की आत्मा का रचनात्मक
          चित्रण है — परंपरा और आधुनिकता का सुंदर संगम।
        </p>
        <br />
      </div> */}

      {/* Mascot Section */}

      <div style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "22px", marginBottom: "15px" }}>
          पुरुष एशिया हॉकी कप 2025 का शुभंकर 'चाँद'
        </h2>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <b>‘चाँद’</b>, जो हमारे राष्ट्रीय पशु बाघ पर आधारित है, पुरुष एशिया
          हॉकी कप 2025 का शुभंकर है। यह साहस, स्फूर्ति और कौशल का प्रतीक है।
          उसका लाल लबादा शक्ति और उत्साह को दर्शाता है, जबकि जादूगर की टोपी हॉकी
          के जादूगर मेजर ध्यानचंद की असाधारण प्रतिभा को विनम्र श्रद्धांजलि देती
          है।
        </p>
        <Row style={{ marginBottom: "0px" }}>
          <Col md={8}>
            <ul style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyleType: "disc" }}>
                'चाँद' का नाम मेजर ध्यानचंद से प्रेरित है, जिन्होंने चाँदनी
                रातों में अभ्यास कर हॉकी में इतिहास रचा। यह शुभंकर बिहार के
                वाल्मीकि टाइगर रिजर्व के गौरवशाली बाघ से भी प्रेरणा लेता है, जो
                शक्ति, चपलता और आत्मविश्वास का प्रतीक है।
              </li>
              <li style={{ listStyleType: "disc" }}>
                हॉकी स्टिक थामे, लक्ष्य पर केंद्रित 'चाँद' अनुशासन, समर्पण और
                जीत के जुनून को दर्शाता है। उसकी टोपी खेल की जादुई कला और बाघ का
                रूप साहस और निर्भीकता का प्रतीक है। उसके सीने पर बना लोगो 'पद्म
                भूषण' मेजर ध्यानचंद के योगदान को सम्मान देता है।
              </li>
              <li style={{ listStyleType: "disc" }}>
                <b>'चाँद'</b> सिर्फ एक शुभंकर नहीं, बल्कि हॉकी के जज़्बे, बिहार के गौरव
                और खेल भावना का प्रतीक है। यह टूर्नामेंट 29 अगस्त, यानी
                राष्ट्रीय खेल दिवस और मेजर ध्यानचंद की जयंती पर शुरू होगा, जो
                हॉकी को नई ऊँचाइयों तक ले जाएगा। 'चाँद' के साथ, बिहार हॉकी के
                भविष्य को बुलंदियों तक ले जाने के लिए तैयार है!
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <img
              src="/img/HeroMensHockeyAsiaCup2025Rajgir/mascot.jpg"
              alt="Description"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
